import React from "react";

// Minimalist needle-thread "U" mark + wordmark
export const Logo = ({ className = "", dark = false, mark = true }) => {
  const ink = dark ? "#F7F5F0" : "#1A2421";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      {mark && (
        <svg width="26" height="30" viewBox="0 0 26 30" fill="none" className="shrink-0">
          <path d="M4 3 V16 C4 22 8.5 26 13 26 C17.5 26 22 22 22 16 V3"
            stroke="#C25934" strokeWidth="2" strokeLinecap="round" fill="none" />
          <circle cx="13" cy="26" r="2" fill="#C25934" />
          <path d="M13 24 C13 20 10 19 10 15" stroke={ink} strokeWidth="1" strokeLinecap="round"
            strokeDasharray="1.5 2.2" fill="none" opacity="0.7" />
        </svg>
      )}
      <div className="leading-none">
        <span className="font-serif italic text-xl" style={{ color: ink }}>Uniform</span>
        <span className="text-xs uppercase tracking-[0.25em] ml-1.5 font-medium" style={{ color: ink }}>Co.</span>
      </div>
    </div>
  );
};

export default Logo;
